import React from 'react';

interface ModalProps {
  dataBackdrop?: boolean;
  id?: string;
  title: string;
  children?: React.ReactNode;
}

export default class Modal extends React.Component<ModalProps, any> {
  static defaultProps = {
    dataBackdrop: true,
    children: null,
    id: '',
  }

  render() {
    return (
      <div className="modal" id={this.props.id} data-backdrop={this.props.dataBackdrop}>
        <div className="modal-dialog">
          <div className="modal-content-shim">
            <div className="modal-header">
              <button className="close" type="button" data-dismiss="modal">
                <i className="fas fa-times" />
              </button>
              <h3 className="modal-title">{this.props.title}</h3>
            </div>
            <div className="modal-body">
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
